{
  "common": {
    "loading": "Loading...",
    "cancel": "Cancel",
    "save": "Save",
    "save_changes": "Save Changes",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "submit": "Submit",
    "saving": "Saving...",
    "sending": "Sending...",
    "error": "Error",
    "success": "Success",
    "warning": "Warning",
    "note": "Note",
    "no_data": "No data",
    "yes": "Yes",
    "no": "No",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "search": "Search",
    "filter": "Filter",
    "all": "All",
    "none": "None",
    "select": "Select",
    "required": "Required",
    "optional": "Optional",
    "actions": "Actions",
    "status": "Status",
    "date": "Date",
    "time": "Time",
    "name": "Name",
    "email": "Email",
    "confirm": "Confirm",
    "add": "Add",
    "done": "Done",
    "unknown": "Unknown",
    "days": "days",
    "to": "to"
  },
  "time": {
    "day": "day",
    "days": "days",
    "hour": "hour",
    "hours": "hours",
    "week": "week",
    "weeks": "weeks",
    "month": "month",
    "months": "months",
    "year": "year",
    "years": "years",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "yesterday": "Yesterday"
  },
  "status": {
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "cancelled": "Cancelled",
    "active": "Active",
    "inactive": "Inactive",
    "deleted": "Deleted",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "available": "Available",
    "coming_soon": "Coming soon"
  },
  "nav": {
    "dashboard": "Dashboard",
    "planner": "Planner",
    "team": "Team",
    "requests": "Requests",
    "calendar": "Calendar",
    "settings": "Settings",
    "audit_trail": "Audit Trail",
    "billing": "Billing",
    "help": "Help",
    "help_center": "Help Center",
    "profile": "Profile",
    "my_balances": "My Balances",
    "leave_history": "Leave History",
    "restart_tour": "Restart Tour",
    "logout": "Sign Out",
    "upgrade": "Upgrade to Pro",
    "upgrade_subtitle": "Unlock all features",
    "view_plans": "View Plans"
  },
  "header": {
    "profile_settings": "Profile Settings",
    "my_profile": "My Profile",
    "workspace": "Workspace",
    "leave_balances": "Leave Balances",
    "no_balances": "No leave balances found."
  },
  "balance": {
    "unlimited": "Unlimited",
    "available": "available",
    "days_left": "days left",
    "used": "used",
    "remaining": "remaining",
    "of": "of"
  },
  "trial": {
    "ends_today": "Your trial ends today!",
    "ends_tomorrow": "Your trial ends tomorrow!",
    "ends_in_days": "Trial ends in {days} days.",
    "upgrade_now": "Upgrade Now"
  },
  "feature_locked": {
    "title": "{feature} is not available in your plan",
    "description": "Upgrade your plan to unlock this feature and more.",
    "button": "View Plans"
  },
  "dashboard": {
    "title": "Dashboard",
    "out_today": "Out Today",
    "out_on_date": "Out on {date}",
    "no_absences": "No absences",
    "upcoming": "Upcoming Absences",
    "upcoming_empty": "No upcoming absences this week",
    "my_balance": "My Leave Balance",
    "my_balances": "My Balances",
    "no_balance_data": "No balance data",
    "next_holiday": "Next Public Holiday",
    "no_holidays": "No upcoming holidays",
    "next_vacation": "My Next Vacation",
    "nothing_booked": "Nothing booked!",
    "upcoming_birthdays": "Upcoming Birthdays",
    "no_birthdays": "No upcoming birthdays",
    "birthday_today": "Today!",
    "birthday_in_days": "in {days} {unit}",
    "everyone_in_office": "Everyone is in the office on this day",
    "request_leave": "Request Leave",
    "view_calendar": "View Calendar",
    "view_planner": "View Planner",
    "contact_support": "Contact Support"
  },
  "support": {
    "title": "Contact Support",
    "success_title": "Message Sent!",
    "success_message": "We'll get back to you as soon as possible.",
    "intro": "Need help? Send us a message and we'll get back to you shortly.",
    "subject_label": "Subject",
    "subject_placeholder": "Brief description of your issue",
    "message_label": "Message",
    "message_placeholder": "Please describe your issue or question in detail...",
    "send_button": "Send Message"
  },
  "requests": {
    "page_title": "Leave Requests",
    "page_subtitle": "Review and manage leave requests",
    "new_request": "Request Leave",
    "unpaid_confirm": "Only {paid} {unit} of this request is covered by your paid balance. The remaining {unpaid} {unit} will be taken as unpaid vacation. Submit anyway?",
    "filter": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "all": "All",
      "all_employees": "All Employees"
    },
    "table": {
      "employee": "Employee",
      "type": "Type",
      "dates": "Dates",
      "duration": "Duration",
      "status": "Status",
      "reason": "Reason",
      "actions": "Actions"
    },
    "action": {
      "approve": "Approve",
      "reject": "Reject",
      "cancel": "Cancel"
    },
    "empty": {
      "title": "No requests found",
      "pending": "No pending requests to review.",
      "filtered": "No leave requests match your filter."
    },
    "modal": {
      "reject_title": "Reject Request",
      "reason_label": "Reason for rejection",
      "reason_placeholder": "Reason for leave request...",
      "reject_button": "Reject",
      "request_title": "Request Leave",
      "employee_label": "Employee",
      "leave_type_label": "Leave Type",
      "start_date_label": "Start Date",
      "end_date_label": "End Date",
      "start_time_label": "Start Time",
      "end_time_label": "End Time",
      "reason_optional": "Reason (optional)",
      "submit_button": "Submit Request",
      "submitting": "Submitting...",
      "minimum_duration": "Minimum: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Team Calendar",
    "page_subtitle": "View team absences and scheduled leave",
    "filters": {
      "button": "Filters"
    },
    "sync": {
      "title": "Sync Your Calendar",
      "description": "Connect your personal calendar to automatically sync approved leave"
    },
    "connect": {
      "google": "Google Calendar",
      "microsoft": "Microsoft Calendar"
    },
    "action": {
      "disconnect": "Disconnect",
      "sync_my_leave": "Sync My Leave",
      "sync_team_leave": "Sync Team Leave"
    },
    "connecting": "Connecting...",
    "syncing": "Syncing...",
    "autosync": {
      "title": "Auto-sync team leave",
      "description": "Automatically add team members' approved leave to your calendar"
    },
    "filter": {
      "department_label": "Department",
      "all_departments": "All Departments",
      "location_label": "Location",
      "all_locations": "All Locations",
      "leave_type_label": "Leave Type",
      "all_types": "All Types",
      "status_label": "Status",
      "all_status": "All Status"
    },
    "nav": {
      "today": "Today"
    },
    "view": {
      "day": "Day",
      "week": "Week",
      "month": "Month"
    },
    "legend": {
      "pending": "Pending",
      "holiday": "Holiday"
    },
    "day_view": {
      "empty": "No leaves on this day"
    },
    "more": "+{count} more"
  },
  "team": {
    "page_title": "Team",
    "page_subtitle": "Manage your team members",
    "tab": {
      "active": "Active",
      "inactive": "Inactive",
      "deleted": "Deleted"
    },
    "add_user": "Add User",
    "import_from_slack": "Import from Slack",
    "search_placeholder": "Search team members...",
    "showing_results": "Showing {showing} of {total} {status} members",
    "table": {
      "name": "Name",
      "email": "Email",
      "department": "Department",
      "role": "Role",
      "status": "Status",
      "actions": "Actions"
    },
    "filter": {
      "search_placeholder": "Search team members...",
      "all_departments": "All Departments",
      "all_locations": "All Locations",
      "all_roles": "All Roles"
    },
    "role": {
      "owner": "Owner",
      "admin": "Admin",
      "approver": "Approver",
      "employee": "Employee",
      "user": "User"
    },
    "card": {
      "no_email": "No email",
      "no_department": "No department",
      "no_location": "No location",
      "reports_to": "Reports to",
      "leave_balances": "Leave Balances"
    },
    "action": {
      "bulk_import": "Bulk Import",
      "invite_member": "Invite Member",
      "edit": "Edit",
      "toil": "TOIL",
      "instances": "Instances",
      "deactivate": "Deactivate",
      "remove": "Remove",
      "activate": "Activate",
      "delete": "Delete",
      "restore": "Restore",
      "permanent_delete": "Permanently Delete"
    },
    "empty": {
      "active_title": "No active team members found",
      "active_description": "Invite team members to get started",
      "inactive_title": "No inactive team members found",
      "inactive_description": "No deactivated users",
      "deleted_title": "No deleted team members found",
      "deleted_description": "No deleted users",
      "adjust_filters": "Try adjusting your filters"
    },
    "modal": {
      "edit_title": "Edit Team Member",
      "role": "Role",
      "owner_role_locked": "The workspace owner's role cannot be changed",
      "department": "Department",
      "no_department": "No Department",
      "location": "Location",
      "no_location": "No Location",
      "holiday_location": "Holiday Location",
      "use_assigned_location": "Use assigned location",
      "holiday_location_help": "Override which country's public holidays apply to this user",
      "manager": "Manager",
      "no_manager": "No Manager",
      "start_date": "Start Date",
      "birthday": "Birthday",
      "birthday_help": "Used for birthday notifications",
      "city": "City (for weather)",
      "city_placeholder": "e.g., Valletta, London, Warsaw",
      "city_help": "Override location's city for personalized weather. Leave blank to use location default.",
      "custom_working_days": "Custom Working Days",
      "custom_working_days_help": "Override the department's default working days for this user (e.g., part-time schedule)",
      "working_days": "Working Days",
      "working_days_help": "Select which days this employee works (leave requests will only count these days)"
    },
    "toil": {
      "title": "Manage TOIL",
      "subtitle": "Time Off In Lieu (TOIL)",
      "current_balance": "Current TOIL Balance",
      "available": "available",
      "granted": "granted",
      "used": "used",
      "hours_to_add": "Hours to Add",
      "hours_placeholder": "e.g., 4 or 8",
      "hours_help": "8 hours = 1 day of TOIL",
      "reason": "Reason",
      "reason_placeholder": "e.g., Worked Saturday for website launch",
      "note": "TOIL hours are added to the user's vacation balance but tracked separately. TOIL does NOT carry over to the next year.",
      "adding": "Adding...",
      "add_hours": "Add TOIL Hours"
    },
    "invite": {
      "title": "Add Team Member",
      "description": "Search for Slack members who haven't been added to the vacation tracker yet. This includes guest members (single-channel and multi-channel guests).",
      "search_placeholder": "Search by name or email...",
      "searching": "Searching Slack users...",
      "no_results": "No matching Slack users found",
      "all_added": "All Slack users have been added already",
      "single_channel_guest": "Single-Channel Guest",
      "multi_channel_guest": "Multi-Channel Guest",
      "adding": "Adding..."
    },
    "bulk": {
      "title": "Bulk Import from Slack",
      "description": "Import team members from your Slack workspace. Choose which types of members to include.",
      "loading": "Loading Slack workspace...",
      "workspace_members": "Slack Workspace Members",
      "full_members": "Full Members",
      "multi_channel_guests": "Multi-Channel Guests",
      "single_channel_guests": "Single-Channel Guests",
      "already_imported": "Already imported: {count} users",
      "who_to_import": "Who do you want to import?",
      "all_members": "All members ({count})",
      "all_members_desc": "Full members + all guest types",
      "full_and_multi": "Full members + multi-channel guests ({count})",
      "full_and_multi_desc": "Excludes single-channel guests",
      "full_only": "Full members only ({count})",
      "full_only_desc": "Excludes all guest types",
      "import_complete": "Import complete!",
      "import_result": "{created} new users imported, {updated} existing users updated",
      "load_failed": "Failed to load Slack workspace data",
      "importing": "Importing...",
      "import_users": "Import {count} Users"
    },
    "instances": {
      "title": "Leave Instances",
      "subtitle": "Per-event leave instances (maternity, paternity, etc.)",
      "loading": "Loading instances...",
      "active": "Active Instances",
      "new_instance": "+ New Instance",
      "leave_type": "Leave Type",
      "select_leave_type": "Select leave type...",
      "name": "Name (optional)",
      "name_placeholder": "e.g., Baby #1, 2025 Sabbatical",
      "start_date": "Start Date",
      "entitlement": "Entitlement",
      "entitlement_placeholder": "e.g., 18",
      "creating": "Creating...",
      "create": "Create Instance",
      "no_active": "No active instances",
      "remaining": "{remaining} of {total} {unit} remaining",
      "started": "Started {date}",
      "mark_complete": "Mark as completed",
      "complete": "Complete",
      "past": "Past Instances",
      "used": "Used {used} of {total} {unit}",
      "closed": "Closed {date}",
      "status_completed": "completed",
      "status_cancelled": "cancelled"
    },
    "confirm": {
      "deactivate": "Are you sure you want to deactivate this user?",
      "delete": "Are you sure you want to delete this user? They will be moved to the Deleted tab.",
      "permanent_delete": "Are you sure you want to PERMANENTLY DELETE {name}?",
      "permanent_delete_warning": "This action cannot be undone. All their leave history and balances will be deleted.",
      "permanent_delete_final": "This is permanent! Click OK to confirm permanent deletion."
    },
    "error": {
      "deactivate": "Failed to deactivate user",
      "activate": "Failed to activate user",
      "delete": "Failed to delete user",
      "restore": "Failed to restore user",
      "permanent_delete": "Failed to permanently delete user"
    }
  },
  "settings": {
    "page_title": "Settings",
    "page_subtitle": "Configure your workspace settings and policies",
    "access_denied": {
      "title": "Admin Access Required",
      "message": "You need admin permissions to access settings."
    },
    "tab": {
      "workspace": "Workspace",
      "departments": "Departments",
      "locations": "Locations",
      "holidays": "Holidays",
      "compliance": "Compliance",
      "balances": "Opening Balances",
      "notifications": "Notifications",
      "integrations": "Integrations",
      "import": "Import",
      "data_management": "Data Management",
      "locked_tooltip": "Upgrade to unlock this feature"
    },
    "workspace": {
      "title": "Workspace Settings",
      "name_label": "Workspace Name",
      "visibility_label": "Leave Visibility",
      "visibility": {
        "all": "Everyone can see all leave",
        "department": "Only see own department",
        "approvers": "Only approvers can see all"
      },
      "save_button": "Save Changes"
    },
    "departments": {
      "title": "Departments",
      "subtitle": "Organise your team into departments with custom policies",
      "add_button": "Add Department",
      "name_label": "Department Name",
      "working_days_label": "Working Days",
      "hours_per_day_label": "Hours per Day",
      "approvers_label": "Approvers",
      "notification_channel_label": "Notification Channel",
      "policies_button": "Manage Policies",
      "edit_button": "Edit",
      "delete_button": "Delete",
      "confirm_delete": "Are you sure you want to delete this department?",
      "no_departments": "No departments created yet"
    },
    "locations": {
      "title": "Locations",
      "subtitle": "Manage office locations and their holiday calendars",
      "add_button": "Add Location",
      "name_label": "Location Name",
      "country_label": "Country",
      "timezone_label": "Timezone",
      "edit_button": "Edit",
      "delete_button": "Delete",
      "no_locations": "No locations created yet"
    },
    "holidays": {
      "title": "Public Holidays",
      "subtitle": "Manage public holidays for each location",
      "add_button": "Add Holiday",
      "location_label": "Location",
      "all_locations": "All Locations",
      "year_label": "Year",
      "name_label": "Holiday Name",
      "date_label": "Date",
      "half_day_label": "Half Day",
      "edit_button": "Edit",
      "delete_button": "Delete",
      "no_holidays": "No holidays for this location and year",
      "import_button": "Import Holidays"
    },
    "leave_types": {
      "title": "Leave Types",
      "subtitle": "Configure leave types and entitlements",
      "add_button": "Add Leave Type",
      "name_label": "Name",
      "color_label": "Colour",
      "unit_label": "Unit",
      "unit": {
        "days": "Days",
        "hours": "Hours"
      },
      "entitlement_label": "Default Entitlement",
      "unlimited": "Unlimited",
      "requires_approval_label": "Requires Approval",
      "allow_half_day_label": "Allow Half Day",
      "is_paid_label": "Paid Leave",
      "carryover_label": "Max Carryover",
      "priority_label": "Priority",
      "edit_button": "Edit",
      "delete_button": "Delete",
      "no_leave_types": "No leave types configured"
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Configure how and when notifications are sent",
      "slack_channel_label": "Slack Channel",
      "email_notifications_label": "Email Notifications",
      "daily_digest_label": "Daily Digest",
      "weekly_summary_label": "Weekly Summary",
      "save_button": "Save Settings"
    },
    "integrations": {
      "title": "Integrations",
      "subtitle": "Connect your HR tools and calendars",
      "connect_button": "Connect",
      "disconnect_button": "Disconnect",
      "sync_button": "Sync Now",
      "view_logs_button": "View Logs",
      "last_sync": "Last synced: {date}",
      "never_synced": "Never synced",
      "status": {
        "connected": "Connected",
        "disconnected": "Not connected",
        "error": "Error"
      }
    },
    "data": {
      "title": "Data Management",
      "subtitle": "Backup your data or clear workspace information",
      "current_data": "Current Data",
      "total_users": "Total Users",
      "admins": "Admins",
      "regular_users": "Regular Users",
      "leave_requests": "Leave Requests",
      "backup": {
        "title": "Download Backup",
        "description": "Download a complete backup of your workspace data as a JSON file.",
        "button": "Download Backup"
      },
      "google_drive": {
        "title": "Google Drive Backup",
        "description": "Automatic daily backups to Google Drive.",
        "connect_button": "Connect Google Drive",
        "folder_label": "Backup Folder",
        "auto_backup_label": "Enable Automatic Daily Backup",
        "backup_now_button": "Backup Now",
        "last_backup": "Last backup: {date}",
        "upgrade_message": "Automatic daily backups to Google Drive is available on the Business plan."
      },
      "clear_users": {
        "title": "Clear Non-Admin Users",
        "description": "Remove all users except admins and owners. This will delete {count} users, their leave balances, and any pending leave requests.",
        "warning": "Warning: This action cannot be undone. Make sure to download a backup first.",
        "confirm_prompt": "Type DELETE to confirm",
        "confirm_description": "This will permanently remove {count} users and all their data.",
        "button": "Clear Non-Admin Users",
        "confirm_button": "Confirm Delete Users"
      },
      "clear_history": {
        "title": "Clear Leave History",
        "description": "Remove all leave requests and reset all leave balances to zero. This will delete {count} leave requests.",
        "warning": "Warning: This action cannot be undone. All leave history will be permanently deleted and balances reset.",
        "confirm_description": "This will permanently delete {count} leave requests and reset all balances.",
        "button": "Clear Leave History",
        "confirm_button": "Confirm Clear History"
      },
      "restore": {
        "title": "Restore from Backup",
        "description": "Upload a backup JSON file to restore your workspace data. This will replace all existing data.",
        "warning": "Warning: Restoring will replace all current users, leave types, leave requests, departments, and balances. Only the workspace owner can perform this action.",
        "select_file": "Select Backup File",
        "backup_details": "Backup Details",
        "file": "File",
        "version": "Version",
        "created": "Created",
        "confirm_prompt": "Type RESTORE to confirm",
        "confirm_description": "This will permanently replace all existing data with the backup.",
        "button": "Confirm Restore",
        "restoring": "Restoring...",
        "success": "Restore completed successfully!"
      }
    }
  },
  "audit": {
    "page_title": "Audit Trail",
    "page_subtitle": "View all changes made in your workspace",
    "super_admin_label": "(Super Admin)",
    "entries_count": "total entries",
    "filter": {
      "action_label": "Action Type",
      "all_actions": "All Actions",
      "entity_label": "Entity Type",
      "all_entities": "All Entities",
      "user_label": "Changed By",
      "all_users": "All Users"
    },
    "action": {
      "user_updated": "User Updated",
      "user_deleted": "User Deleted",
      "user_imported": "User Imported",
      "leave_requested": "Leave Requested",
      "leave_approved": "Leave Approved",
      "leave_rejected": "Leave Rejected",
      "leave_cancelled": "Leave Cancelled",
      "leave_type_created": "Leave Type Created",
      "leave_type_updated": "Leave Type Updated",
      "leave_type_deleted": "Leave Type Deleted",
      "balance_adjusted": "Balance Adjusted",
      "department_created": "Department Created",
      "department_updated": "Department Updated",
      "department_deleted": "Department Deleted",
      "audit_log_deleted": "Audit Log Deleted"
    },
    "table": {
      "date": "Date",
      "user": "User",
      "action": "Action",
      "entity": "Entity",
      "details": "Details"
    },
    "no_entries": "No audit log entries found"
  },
  "billing": {
    "page_title": "Billing & Subscription",
    "page_subtitle": "Manage your subscription and billing details",
    "access_denied": {
      "title": "Access Denied",
      "message": "Only the workspace owner can view and manage billing.",
      "button": "Return to Dashboard"
    },
    "current_plan": {
      "title": "Current Plan"
    },
    "status": {
      "none": "No subscription"
    },
    "discount_badge": "{percent}% discount applied",
    "trial_info": {
      "title": "Trial ends {date}",
      "days_remaining": "{days} days remaining"
    },
    "renewal_info": {
      "title": "Next billing date"
    },
    "action": {
      "upgrade": "Upgrade to Pro",
      "view_plans": "View All Plans",
      "manage": "Manage Subscription"
    },
    "plan": {
      "trial": "Free Trial",
      "free": "Free",
      "pro": "Pro",
      "business": "Business"
    },
    "feature": {
      "up_to_5_users": "Up to 5 users",
      "up_to_50_users": "Up to 50 users",
      "unlimited_users": "Unlimited users",
      "basic": "Basic features",
      "trial_14days": "14-day trial",
      "unlimited_requests": "Unlimited leave requests",
      "slack_integration": "Slack integration",
      "planner": "Planner view",
      "custom_leave_types": "Custom leave types",
      "approval_workflows": "Approval workflows",
      "priority_support": "Priority support",
      "multi_team": "Multi-team support",
      "analytics": "Advanced analytics",
      "api_access": "API access",
      "dedicated_support": "Dedicated support"
    }
  },
  "upgrade": {
    "page_title": "Choose Your Plan",
    "page_subtitle": "Simple, transparent pricing. No per-user fees.",
    "plan_badge": "Most Popular",
    "period": {
      "month": "/month",
      "year": "/year"
    },
    "yearly_savings": "or EUR {yearly}/year (save {percent}%)",
    "loading": "Loading plans...",
    "guarantee": {
      "title": "30-day money-back guarantee",
      "description": "Not satisfied? Get a full refund, no questions asked."
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "q1": "Can I change plans later?",
      "a1": "Yes, you can upgrade or downgrade at any time. Changes take effect immediately and are prorated.",
      "q2": "What payment methods do you accept?",
      "a2": "We accept all major credit cards (Visa, Mastercard, American Express) through our secure payment provider Stripe.",
      "q3": "Is there a contract or commitment?",
      "a3": "No, all plans are month-to-month. You can cancel anytime with no penalties.",
      "q4": "What happens when I reach my user limit?",
      "a4": "You'll be prompted to upgrade to a higher plan. Existing users will continue to have access."
    },
    "contact_note": "Have questions? Contact us at",
    "current_plan_badge": "Current Plan",
    "button": {
      "upgrade": "Upgrade to {plan}",
      "start_trial": "Start Free Trial"
    }
  },
  "login": {
    "processing_title": "Signing you in...",
    "processing_message": "Please wait while we verify your credentials from Slack.",
    "subtitle": "Manage your team's time off requests with ease",
    "slack_button": "Add to Slack",
    "existing_user_text": "Already using Unplug?",
    "existing_user_info": "Open the app in Slack and click Admin Dashboard to sign in.",
    "terms_text": "By continuing",
    "error": {
      "workspace_not_found": "Workspace not found. Please check the URL.",
      "invalid_response": "Invalid response from server",
      "generic": "Login failed",
      "please_retry": "Login failed. Please try again."
    }
  },
  "help": {
    "page_title": "Help Center",
    "page_subtitle": "Find answers and learn how to use Unplug",
    "action": {
      "restart_tour": "Restart Tour"
    },
    "search": {
      "placeholder": "Search help articles, FAQs...",
      "results": "Found {articles} articles and {faqs} FAQs matching {query}"
    },
    "quick_link": {
      "getting_started": "Getting Started",
      "faqs": "FAQs",
      "contact_support": "Contact Support",
      "tour": "Take the Tour"
    }
  },
  "profile": {
    "page_title": "Profile Settings",
    "personal_info": "Personal Information",
    "name_label": "Full Name",
    "email_label": "Email",
    "department_label": "Department",
    "location_label": "Location",
    "manager_label": "Manager",
    "start_date_label": "Start Date",
    "save_button": "Save Changes",
    "preferences": "Preferences",
    "language_label": "Language",
    "timezone_label": "Timezone"
  },
  "planner": {
    "page_title": "Planner",
    "page_subtitle": "Visual team calendar showing all absences",
    "feature_name": "Planner",
    "feature_description": "Visual team calendar showing all absences at a glance",
    "empty_state": "No team members found",
    "filter": {
      "pending_request": "Pending request",
      "filter_by": "Filter by",
      "department": "Department",
      "all_departments": "All Departments",
      "location": "Location",
      "all_locations": "All Locations"
    },
    "export": {
      "button": "Export",
      "title": "Export Leave Data",
      "format": "Export Format",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "Generic CSV",
      "date_range": "Date Range",
      "departments": "Departments"
    },
    "legend": {
      "approved": "Approved",
      "pending": "Pending",
      "holiday": "Public Holiday",
      "holidays": "Holidays",
      "weekend": "Weekend",
      "non_working": "Non working day",
      "partial_day": "Leaves shorter than a day"
    },
    "no_data": "No absences to display"
  },
  "error": {
    "network": "Network error. Please check your connection.",
    "unauthorized": "You are not authorized to perform this action.",
    "not_found": "The requested resource was not found.",
    "server": "Server error. Please try again later.",
    "validation": "Please check the form for errors.",
    "generic": "Something went wrong. Please try again.",
    "session_expired": "Your session has expired. Please log in again."
  },
  "success": {
    "saved": "Changes saved successfully.",
    "deleted": "Deleted successfully.",
    "created": "Created successfully.",
    "updated": "Updated successfully.",
    "submitted": "Submitted successfully.",
    "sent": "Sent successfully."
  },
  "weekday": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "sun": "Sun"
  },
  "month": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "jan": "Jan",
    "feb": "Feb",
    "mar": "Mar",
    "apr": "Apr",
    "may_short": "May",
    "jun": "Jun",
    "jul": "Jul",
    "aug": "Aug",
    "sep": "Sep",
    "oct": "Oct",
    "nov": "Nov",
    "dec": "Dec"
  },
  "language": {
    "en": "English",
    "es": "Spanish",
    "fr": "French",
    "de": "German",
    "it": "Italian",
    "pt": "Portuguese",
    "pl": "Polish",
    "nl": "Dutch",
    "sv": "Swedish",
    "no": "Norwegian"
  },
  "leave_type_name": {
    "Vacation": "Vacation",
    "Vacation Leave": "Vacation Leave",
    "Annual Leave": "Annual Leave",
    "Unpaid Vacation": "Unpaid Vacation",
    "Unpaid Leave": "Unpaid Leave",
    "Sick Leave": "Sick Leave",
    "Sick Leave (Full Pay)": "Sick Leave (Full Pay)",
    "Maternity Leave": "Maternity Leave",
    "Paternity Leave": "Paternity Leave",
    "Parental Leave": "Parental Leave",
    "Bereavement Leave": "Bereavement Leave",
    "Marriage Leave": "Marriage Leave",
    "Jury Leave": "Jury Leave",
    "Jury Duty": "Jury Duty",
    "Work Travel": "Work Travel",
    "Working Remotely": "Working Remotely",
    "Remote Work": "Remote Work",
    "Work From Home": "Work From Home",
    "Personal Day": "Personal Day",
    "TOIL": "TOIL",
    "Time Off In Lieu": "Time Off In Lieu",
    "Compassionate Leave": "Compassionate Leave",
    "Study Leave": "Study Leave",
    "Training": "Training",
    "Public Holiday": "Public Holiday"
  }
}